
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect } from 'react-router-dom';
import { changeState, logout, mudarMensagens } from '../actions/AppActions';
import { connect } from 'react-redux';

// users
import user4 from '../assets/images/users/user-4.jpg';
import moment from 'moment-timezone';
import NaoIniciada from './NaoIniciada';
import { DEBUG, URL } from '../variables';
import AceiteRegras from './AceiteRegras';
import AvaliacaoAndamento from './AvaliacaoAndamento';
import Finalizada from './Finalizada';
import MeetingRoom from './Meet';
//

import { createGlobalStyle } from 'styled-components';
import { ProgressBar } from 'react-bootstrap';
import Chat from './Chat';
import SweetAlert from 'react-bootstrap-sweetalert';
import { CandidateLoader } from './CandidateUi';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { ServerClock } from './serverClock';
let silence = () => {
    let ctx = new AudioContext(), oscillator = ctx.createOscillator();
    let dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}
const StyleQuestion = createGlobalStyle`
 *::selection {
    background-color: #f1c40f !important;
    color:black !important;
    font-weight:bold !important;
 }
`

class ProcessoUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            nao_iniciado: false,
            regras_processo: false,
            andamento: false,
            finalizada: false,
            loading_screen: true,
            finish: false,
            full_screen: false,
            need_face_validation: false,
            chat_show: false,
            message_access: '',
            loading_access: false,
            request_validation: {},
            show_warning_decline: false,
            show_warning_approved: false,
            show_btn_validation_timer: false,
            show_btn_validation: false
        };
        this.need_delete_validation = []
        this.serverClock = new ServerClock();
    }




    solicitar_camera(rules) {
        // this.setState({ loading_camera: true, msg: '', show_solicitar: false });
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(() => this.get_camera(rules)).catch(this.handleError.bind(this));
    }

    async get_camera(rules) {

        var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        console.log(devices);
        let exists = false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []

        for (let i = 0; i < devices.length; i++) {
            if (devices[i].kind == 'videoinput') {
                if (!devices_cam_id.includes(devices[i].deviceId)) {
                    devices_camera.push(devices[i]);
                    devices_cam_id.push(devices[i].deviceId);

                }
                if (device_local == devices[i].deviceId) {
                    exists = true;
                }
            }
            else if (devices[i].kind == 'audioinput') {
                if (!devices_mic_id.includes(devices[i].deviceId)) {
                    devices_mic.push(devices[i]);
                    devices_mic_id.push(devices[i].deviceId);

                }
            }

        }
        console.log(devices_camera);
        console.log('oi');
        if (devices_camera.length > 0 && devices_mic.length > 0 || true) {
            let use = '';
            if (exists == true) {
                use = device_local;
            }
            else if (devices_camera.length > 0) {
                use = devices_camera[0].deviceId;
                localStorage.setItem("deviceId", use);
            }
            let videoConstraints = {
                frameRate: 4,
                width: 320,
                height: 240
            };
            if (use) {
                videoConstraints.deviceId = { exact: use };
            }
            console.log(use)
            this.props.changeState({ devices_camera: devices_camera, devices_mic, device_select: use })
            navigator.mediaDevices.getUserMedia({
                video: videoConstraints, audio: true
            }).
                then((str) => this.handleSuccess(str, rules)).catch(this.handleError.bind(this));
        }
        else {
            this.setState({ show_solicitar: true, loading_camera: false, msg: 'Não foi reconhecido nenhuma câmera ou microfone conectado em seu computador. Conecte e tente novamente' })
        }
    }


    handleSuccess(stream, rules) {
        stream.oninactive = () => {
            try {
                this.salvar_log_permission('Cancelou permissão de câmera');
            }
            catch (e) {

            }
            this.props.history.push({
                pathname: '/',
                search: '?error=Compartilhamento de Vídeo/Áudio foi cancelado pelo candidato. Compartilhe novamente para realizar a avaliação'
            });
        }
        // this.get_processo();
        this.salvar_log_permission('Aceitou permissão de câmera');


        this.props.changeState({ stream });
        this.aceitar_regras(this.resp);
        this.get_time_server();

    }

    handleError(stream) {
        console.log(stream);
        let msg = '';
        if (stream.name === 'NotAllowedError' || stream.toString().includes('NotAllowedError') || stream.toString().includes('Permission denied')) {
            msg = 'O navegador bloqueou o acesso à câmera ou ao microfone. Libere câmera e microfone nas permissões do navegador e do sistema operacional, feche outros aplicativos que possam estar usando os dispositivos e tente novamente.';
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = 'Aceita as permissões de acesso a câmera para poder avançar.';
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = 'Não foi possível acessar sua câmera. Conecte uma câmera, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = 'Não foi possível acessar seu microfone. Conecte um microfone, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = 'Não foram reconhecidos nenhuma câmera ou microfone conectados em seu computador. Conecte-os e tente novamente.';
        }
        else {
            msg = stream.toString();
        }
        this.salvar_log_permission(msg + ' ' + stream.toString());
        this.setState({ redirect: true });

    }

    componentDidMount() {
        this.clicked = false;
        this.unmount = false;
        this.get_processo();
    }

    salvar_log_permission(msg, type = 'permission') {
        fetch(`${URL}api/external/salvar_log?screen=${type}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}&external=1`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);

            });
    }


    componentWillUnmount() {
        this.unmount = true;

        clearTimeout(this.timeout_get_processo)
        clearTimeout(this.timeout_timeserver)
        clearTimeout(this.timer_timeout)
        clearTimeout(this.request_access_timeout)
        clearTimeout(this.timeout_btn_validation)
        clearInterval(this.timeout_request_delete)
        clearInterval(this.timeout_validation)
    }




    get_processo(flag = '') {
        if (this.props.processo != null && this.props.processo.is_interview && this.props.socket != null) {
            this.props.socket.emit('exit_call', { aluno_id: this.props.user.id, processo_id: this.props.processo.id, id: this.props.user.id })
        }

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/external/get_processo${flag}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == 'Server Error') {
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                    return;
                }
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;

                }
                if (resp.errors != null || resp.error != null || resp.message == 'Server Error') {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                    this.timeout_get_processo = setTimeout(() => {
                        this.get_processo();
                    }, 5000);
                }
                else {
                    this.resp = resp;
                    if (resp.processo != null && (resp.processo.type_fiscalization == 'all' || resp.processo.type_fiscalization == 'image') && this.props.stream == null && resp.processo_resultado != null && resp.processo_resultado.status == 'I') {
                        // this.setState({ loading_screen: true });

                        this.solicitar_camera(true);
                    }
                    else {
                        this.aceitar_regras(resp);
                    }


                }
            } catch (err) {
                // this.setState({ redirect: true });
                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            }

        })
            .catch((err) => {
                // this.setState({ redirect: true });

                console.log(err);
                this.timeout_get_processo = setTimeout(() => {
                    this.get_processo();
                }, 5000);
            });
    }
    goToRules(flag = '') {
        // this.get_time_server();
        this.get_processo(flag);

    }

    aceitar_regras(resp) {
        if (resp.not_processo == true) {
            this.props.changeState({ processo: null });
            return;
        }

        // this.props.mudarUser(resp.user);
        // this.props.mudarProcesso(resp.processo);
        // this.props.mudarSala(resp.sala);
        // this.props.mudarTempoAtual(resp.tempo_atual);
        // if (this.props.stream == null && resp.finish != true ) {
        //     this.solicitar_camera();
        //     return;
        // }
        let processo_resultado = {};
        if (resp.processo_resultado != null) {
            processo_resultado.processo_resultado = resp.processo_resultado;
        }


        this.props.changeState({ request_user: resp.request_user, entrevistas: resp.entrevistas, mensagens: resp.mensagens, redacoes: resp.redacoes, questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });

        // else if (resp.processo.fim != this.props.processo.fim || resp.processo.updated_at != this.props.processo.updated_at) {
        //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, processo: resp.processo, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
        // }
        // else {
        //     this.props.changeState({ mensagens: resp.mensagens, redacoes: resp.redacoes,questionarios: resp.questionarios, provas: resp.provas, categorias: resp.categorias, user: resp.user, sala: resp.sala, tempo_atual: resp.tempo_atual, ...processo_resultado });
        // }
        this.setState({ request_validation: resp.request_validation != null ? resp.request_validation : this.state.request_validation, need_face_validation: (this.validation == true || this.state.request_validation?.approved == true || (this.props.left_movement == true && this.props.center_movement && this.props.right_movement && this.props.audio_detected)) ? false : true, loading_screen: false, finish: resp.andamento?false:true, nao_iniciado: false, regras_processo: false, andamento: resp.andamento, finalizada: false });
        if (resp.tempo_atual) {
            clearTimeout(this.timer_timeout);
            this.serverClock.sync(resp.tempo_atual);
            this.incTimer();
        }



    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }







    get_time_server() {

        fetch(`${URL}api/get_time_server`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else if (resp.message == "Server Error") {
                    this.timeout_timeserver = setTimeout(() => {
                        this.get_time_server();
                    }, 5000);
                }
                else {
                    if (resp.atual != null) {
                        this.serverClock.sync(resp.atual);
                        this.props.changeState({ tempo_atual: resp.atual });
                    }
                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);
                this.timeout_timeserver = setTimeout(() => {
                    this.get_time_server();
                }, 5000);
            });
    }



    incTimer() {
        if (!this.serverClock.isReady()) {
            this.timer_timeout = setTimeout(() => this.incTimer(), 1000);
            return;
        }

        var totalSecs = this.serverClock.secondsUntil(this.props.processo.inicio);

        // console.log($('#inicio_id').val())
        // console.log(moment().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss'))
        // var totalSecs = tempo - iniciado;

        // totalSecs--;
        console.log(totalSecs)
        let data = {}
        if (totalSecs <= this.props.processo.chat_time && this.state.chat_show == false) {
            data.chat_show = true;
        }
        if (totalSecs <= this.props.processo.request_time && this.state.show_btn_validation_timer == false) {
            console.log('entrou')
            data.show_btn_validation_timer = true;
        }
        else {
            if (totalSecs % 30 == 0 && this.state.show_btn_validation_timer == false) {
                this.get_time_server()
            }
        }
        if (Object.keys(data).length != 0) {
            this.setState(data);
        }
        // if(document.getElementById('total_secs')!=null){
        //     try{
        //         document.getElementById('total_secs').innerText=totalSecs+'_'+before_second_diff+'_'+this.seconds_diff;
        //     }
        //     catch(e){

        //     }
        // }
        if (totalSecs <= 0) {
            totalSecs = 0;
            this.iniciado = true;
        }
        else {


            this.timer_timeout = setTimeout(function () {
                this.incTimer()
            }.bind(this), 1000);
        }
    }


    renderTips() {
        const t = getLanguageTexts(getSelectedLanguage());
        if (this.props.processo.face_validation == true) {
            if (this.props.loading_media) {
                return (<CandidateLoader compact title={t.loading_information} description={null} />)
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == false) {
                console.log('nenhum rosto');
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.no_face_detected}</p>)
            }
            else if (this.props.face_detected == false && this.props.multipleface_detected == true) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.multiple_faces_detected}</p>)
            }
            else if (this.props.center_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.center_face}</p>)
            }
            else if (this.props.right_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.turn_right}</p>)
            }
            else if (this.props.left_movement == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.turn_left}</p>)
            }
            else if (this.props.audio_detected == false) {
                return (<p className='blink' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'darkgoldenrod', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.speak_to_validate_microphone}</p>)
            }
            else {
                return (<p className='blink_success' style={{ textAlign: 'center', padding: 10, textTransform: 'uppercase', color: 'green', fontWeight: 'bold', fontSize: 18, border: '1px dashed', borderRadius: 10, marginTop: 20, marginBottom: 20 }}>{t.device_validation_done}</p>)
            }
        }
        else {
            return '';
        }
    }

    access_exam() {
        this.validation = true;
        this.get_time_server()

        this.props.changeStateParent({ show_btn_change: false })
        this.setState({ need_face_validation: false, show_warning_approved: false, show_btn_validation: false }, () => {
            if (this.clicked == false && this.props.processo.full_screen == true) {
                this.clicked = true;
            }
        });

    }


    render() {//
        const t = getLanguageTexts(getSelectedLanguage());
        return (
            <div className="external-camera-flow" onClick={() => {
                document.body.style.userSelect = 'text';
            }} onCopy={(e) => {
                e.preventDefault();
            }}
                onCut={(e) => e.preventDefault()}
                onDrop={(e) => e.preventDefault()}
                onChange={(e) => e.preventDefault()}

            >
                {this.props.user?.accessibility == true && this.props.user?.type_supervisor != 'none' && <StyleQuestion />}
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                <div className="external-camera-card">
                    <div className="external-camera-card-body" id="card">
                            <div hidden id="total_secs"></div>

                            <div className="external-camera-title-row">
                                <span className="candidate-auth-kicker">{t.process}</span>
                                <h4 id='titulo_processo'>{this.props.processo.name}</h4>
                                <p>{t.candidate_name}: {this.props.user.name}</p>
                            </div>

                            {this.props.processo.type_time == 'all' && <>
                                <div className="external-camera-meta">
                                    <div className="external-camera-meta-item">
                                        <small>{t.start_time}</small>
                                        <strong>{moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}</strong>
                                    </div>
                                    <div className="external-camera-meta-item">
                                        <small>{t.end_time}</small>
                                        <strong>{moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}</strong>
                                    </div>
                                </div>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto == null && <>
                                <div className="external-camera-meta">
                                    <div className="external-camera-meta-item"><small>{t.process_start_time}</small><strong>{moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm')}</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.process_end_time}</small><strong>{moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm')}</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.started_at}</small><strong>-</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.finishes_at}</small><strong>-</strong></div>
                                </div>
                            </>}

                            {this.props.processo.type_time == 'restrict' && this.props.processo.inicio_absoluto != null && <>
                                <div className="external-camera-meta">
                                    <div className="external-camera-meta-item"><small>{t.process_start_time}</small><strong>{moment(this.props.processo.inicio_absoluto).format('DD/MM/YYYY HH:mm')}</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.process_end_time}</small><strong>{moment(this.props.processo.fim_absoluto).format('DD/MM/YYYY HH:mm')}</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.started_at}</small><strong>{moment(this.props.processo.inicio).format('DD/MM/YYYY HH:mm:ss')}</strong></div>
                                    <div className="external-camera-meta-item"><small>{t.finishes_at}</small><strong>{moment(this.props.processo.fim).format('DD/MM/YYYY HH:mm:ss')}</strong></div>
                                </div>
                            </>}

                            {this.state.loading_screen == false && <div>
                                {<>
                                    {this.props.processo.descricao && <div className="external-camera-terms">
                                        <strong>{t.evaluation_description}</strong>
                                        <p style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{this.props.processo.descricao}</p>
                                    </div>}
                                    <div >


                                        {this.state.andamento && <AvaliacaoAndamento changeStateParent={(e) => this.props.changeStateParent(e)} getValues={() => this.props.getValues()} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                        {this.state.finish && <Finalizada changeStateParent={(e) => this.props.changeStateParent(e)} getValues={() => this.props.getValues()} send_message={(m) => this.send_message(m)} aceitar_regras={this.aceitar_regras.bind(this)} get_processo={this.get_processo.bind(this)} {...this.props} />}
                                    
                                    </div>


                                </>}

                            </div>}
                            {<div id='timer'
                                className='timer_exam'>

                            </div>}

                            {this.state.loading_screen == true && <CandidateLoader title={t.loading_data} description={t.updating_process_status} />}


                    </div>
                </div>
            </div>
        );
    }
}
const mapsStateToProps = (state) => (
    {
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        token: state.AppReducer.token,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        processo_resultado: state.AppReducer.processo_resultado,
        // worker: state.AppReducer.worker,
        sala: state.AppReducer.sala,
        faculdade: state.AppReducer.faculdade,
        show_call: state.AppReducer.show_call,
        mensagens: state.AppReducer.mensagens,

        socket: state.AppReducer.socket,
        connect: state.AppReducer.connect,
        request_user: state.AppReducer.request_user,


    }
);

export default connect(mapsStateToProps, { changeState, logout, mudarMensagens })(ProcessoUser);
